/**
 * 应用配置
 */
export const APP_CONFIG = {
  name: 'AI资料自主测试系统',
  version: '1.0.0',
  description: 'AI Document Testing System',
  sidebar: {
    /** 评测管理菜单默认是否折叠（通过 VITE_SIDEBAR_EVALUATION_COLLAPSED 环境变量配置） */
    evaluationCollapsed: import.meta.env.VITE_SIDEBAR_EVALUATION_COLLAPSED === 'true',
  },
} as const
